<!-- =========================================================================================
  File Name: ExhibitorBusinessCardDetailsList.vue
  Description: Exhibitor Business Card Exchange List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.option-inner-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
}
.option-inner-wrap li {
  list-style: none;
  width: 50%;
  padding: 10px;
}
</style>
<template>
  <div id="page-user-list">
    <div class="header-custome">
      <h3>Business Card Exchange
      <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows  + ")": ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec">
        <a href="#">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span> Need help with this section?
        </a>
      </div>
    </div>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ businessCardData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : businessCardData.length }} of {{ businessCardData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="businessCardData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";
import moment from "moment-timezone";
import parser from "ua-parser-js";

import ls from "@/common/localStorage";
import con from "@/firebase/firebaseInit.ts";
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
import { AgGridVueCategory } from "ag-grid-vue";
var vm;
export default {
  components: {
    AgGridVue,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    AgGridVueCategory,
    // CategoryCellRendererActions,
  },
  data() {
    return {
      gridSelectedRows: 0,
      businessCardData: [],
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],

      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridCategoryApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      defaultColDefCategory: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      gridOptionsCategory: {},

      columnDefs: [
        {
          //headerName: 'ID',
          //field: 'id',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
      {
          headerName: "Exchanged By",
          field: "ExchangedByName",
          filter: true,
          width: 200,
          pinned: "left",
        },
        {
          headerName: "Email",
          field: "ExchangedByEmail",
          filter: true,
          width: 200,
        },
        {
          headerName: "Booth Id",
          field: "ExchangedWithBoothId",
          filter: true,
          width: 150,
        },
          {
          headerName: "Booth Name",
          field: "ExchangedWithBoothName",
          filter: true,
          width: 150,
        },
        //  {
        //   headerName: "Created On",
        //   field: "CreatedDate",
        //   cellRenderer: (data) => {
        //     return data.value
        //       ? this.SetTimeByZone(
        //           new Date(data.value.seconds * 1000).toUTCString(),
        //           Session_Event_TZ
        //         )
        //       : "";
        //   },
        //   filter: true,
        //   width: 150,
        // },
         {
          headerName: "Device Info",
          field: "DeviceInfo",
          filter: true,
          width: 300
        }
      ],
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        AgGridVueCategory,
        // CategoryCellRendererActions,
      },
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    paginationPageSizeCategory() {
      if (this.gridCategoryApi)
        return this.gridCategoryApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    totalPagesCategory() {
      if (this.gridCategoryApi)
        return this.gridCategoryApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    currentPageCategory: {
      get() {
        if (this.gridCategoryApi)
          return this.gridCategoryApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridCategoryApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];

        datarow.push("Exchanged By");
        datarow.push("Email");
        datarow.push("Booth Id");
        datarow.push("Booth Name");
        var ExchangeData = [];
        ExchangeData.push(datarow);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          var exchangedByEmail = row.ExchangedByEmail == undefined ? "" : row.ExchangedByEmail;
          datarow.push('"' + exchangedByEmail + '"');
          var exchangedByName = row.ExchangedByName == undefined ? "" : row.ExchangedByName;
          datarow.push('"' + exchangedByName + '"');
          var exchangedWithBoothId = row.ExchangedWithBoothId == undefined ? "" : row.ExchangedWithBoothId;
          datarow.push('"' + exchangedWithBoothId + '"');
          var exchangedwithBoothName = row.ExchangedWithBoothName == undefined ? "" : row.ExchangedWithBoothName;
          datarow.push('"' + exchangedwithBoothName + '"');
          ExchangeData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        ExchangeData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "ExchangeData_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one exchange data to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    getDevice: function(uastring) {
      debugger;
      var retVal = "";
      var result = parser(uastring);

      //console.log(parser);
      console.log(result);
      //parser.setUA(uastring);
      //var result = parser.getResult();
      // this will also produce the same result (without instantiation):
      // var result = UAParser(uastring);
      if (result.device != undefined) {
        if (result.device.vendor != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.device.vendor;
          if (result.device.model != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.device.model;
          }
        }
      }
      if (result.os != undefined) {
        if (result.os.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.os.name;
          if (result.os.version != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.os.version;
          }
        }
      }
      if (result.browser != undefined) {
        if (result.browser.name != undefined) {
          if (retVal != "") {
            retVal += ", ";
          }
          retVal += result.browser.name;
          if (result.browser.major != undefined) {
            if (retVal != "") {
              retVal += " ";
            }
            retVal += result.browser.major;
          }
        }
      }
      return retVal;
      //console.log(result.browser);        // {name: "Chromium", version: "15.0.874.106"}
      //console.log(result.device);         // {model: undefined, type: undefined, vendor: undefined}
      //console.log(result.os);             // {name: "Ubuntu", version: "11.10"}
      //console.log(result.os.version);     // "11.10"
      //console.log(result.engine.name);    // "WebKit"
      //console.log(result.cpu.architecture);   // "amd64"
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
     fetchBusinessCardDetails() {
      this.$store
        .dispatch("exhibitorManagement/fetchBusinessCardDetails")
        .then((res) => {
          this.businessCardData = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridCategoryApi = this.gridOptionsCategory.api;
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    //-----------------------------------------------------------------------------------------------------------
    //-----------GEt Business Card Listing------------------------------------------------------------------------------
    // this.$vs.loading();
    // var cn = ls.getSessionEventCollectionName();
    // var cref = con.eventDB
    // .collection(cn)
    // .doc('Analytics')
    // .collection('BusinessCardExchange');
    //     cref.get().then((querySnapshot) => {
    //   querySnapshot.forEach((doc) => {
    //     this.businessCardData.push({
    //       ExchangedByName: doc.data().ExchangedByName,
    //       ExchangedByEmail: doc.data().ExchangedByEmail,
    //       ExchangedWithBoothId: doc.data().ExchangedWithBoothID,
    //       ExchangedWithBoothName: doc.data().ExchangedWithBoothName,
    //       DeviceInfo: this.getDevice(doc.data().UserAgent),
    //       CreatedDate: doc.data().Timestamp
    //     });
    //   });
    //   this.$vs.loading.close();
    // });
     

  },
  created() {
        if (!moduleExhibitorManagement.isRegistered) {
      this.$store.registerModule("exhibitorManagement", moduleExhibitorManagement);
      moduleExhibitorManagement.isRegistered = true;
    }
    this.fetchBusinessCardDetails();
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>